import { JRPCDto } from '@lentau/api/shared/jrpc/types';
import { RequestData } from '@lentau/api/shared/monolith/types';

type MethodData = { methodName: string; methodData: unknown };
type MethodBody = RequestData | JRPCDto<unknown>;

//TEMP
export function getMethodData(body: MethodBody): MethodData {
  if (isRestBody(body)) {
    return { methodName: body.Head.Method, methodData: body.Body };
  }

  if (isJrpcBody(body)) {
    const name = body.id.split('_')[0];

    return { methodName: name, methodData: body.result };
  }

  return { methodName: '', methodData: body };
}

function isRestBody(body: MethodBody): body is RequestData {
  return (body as RequestData).Head !== undefined;
}

function isJrpcBody(body: MethodBody): body is JRPCDto<unknown> {
  const id: string = (body as JRPCDto<unknown>).id;
  return id !== undefined && !!id.split;
}
